import AppointmentInt from "../../domain/appointments/AppointmentInt";
import { AppointmentsListItem } from "./AppointmentItem";

export interface AppointmentsProps {
  appointments: AppointmentInt[];
}

const parseDate = (dateString: string): Date => {
  const [day, month, year] = dateString.split(".").map(Number);
  return new Date(year, month - 1, day);
};

const SortedAppointments = ({ appointments }: AppointmentsProps) => {
  const sortedAppointments = [...appointments].sort(
    (a, b) =>
      parseDate(a.startdate).getTime() - parseDate(b.startdate).getTime()
  );

  return (
    <>
      {sortedAppointments.map((a) => (
        <AppointmentsListItem key={a.id} appointment={a} />
      ))}
    </>
  );
};

export const Appointments = ({ appointments }: AppointmentsProps) => {
  return (
    <>
      <SortedAppointments appointments={appointments} />
    </>
  );
};

// export const LimitedAppointments = ({ appointments }: AppointmentsProps) => {
//   return (
//     <>
//       {appointments.slice(0, 3).map((a) => (
//         <AppointmentsListItem key={a.id} appointment={a} />
//       ))}
//     </>
//   );
// };

const getNextAppointments = (
  appointments: AppointmentInt[]
): AppointmentInt[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingAppointments = appointments
    .filter((appointment) => parseDate(appointment.startdate) >= today)
    .sort(
      (a, b) =>
        parseDate(a.startdate).getTime() - parseDate(b.startdate).getTime()
    );

  return upcomingAppointments.slice(0, 3);
};

export const LimitedAppointments = ({ appointments }: AppointmentsProps) => {
  const nextAppointments = getNextAppointments(appointments);

  return (
    <>
      {nextAppointments.map((a) => (
        <AppointmentsListItem key={a.id} appointment={a} />
      ))}
    </>
  );
};
